import { type Breakpoint, type Space, spaces, unit } from '../variables';
import { objectToBreakpoints } from './responsive';

import { arrayToBreakpoints } from '.';

export const u = (amount: number) =>
  amount && `calc(${amount} * var(--lns-unit, ${unit}px))`;

/**
 * @example
 * Sample values: "large", 42, "80px"
 */
export type Size = Space | number | string;

export const getSizeValue = (size: Size) => {
  if (size in spaces) {
    return `var(--lns-space-${size})`;
  }

  if (size && isNaN(size as number)) {
    return `${size}`;
  }

  if (size === 0) {
    return `0`;
  }

  if (size) {
    return `${u(size as number)}`;
  }
};

export type SizeProp =
  | Size
  | Size[]
  | Partial<Record<Breakpoint | 'default', Size>>;
export const getSize = (property: string, size: SizeProp) => {
  if (size || size === 0) {
    if (Array.isArray(size)) {
      const rulesetsArray = size.map(sizeItem => {
        return `${property}: ${getSizeValue(sizeItem)}`;
      });

      return arrayToBreakpoints(rulesetsArray);
    }

    if (typeof size === 'object') {
      const sizeValesObject: Partial<Record<Breakpoint, string>> = {};

      Object.entries(size).forEach(
        ([key, value]) => (sizeValesObject[key] = getSizeValue(value))
      );

      return objectToBreakpoints(property, sizeValesObject);
    }

    return `${property}: ${getSizeValue(size)};`;
  }
};
